import axios from '@/api/config';

const student = {
  getStudentById(data) {
    return axios.get(`${process.env.BASE_URL}/student/getStudent/` + data, {});
  },
  getStudent(data) {
    return axios.get(`${process.env.BASE_URL}/student/getStudent`, {params: data});
   },
  getStudentList(data) {
    return axios.get(`${process.env.BASE_URL}/student/getStudentList`, {params: data});
  },
  getStudentTree(data) {
    return axios.get(`${process.env.BASE_URL}/student/getStudentTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/student/pageList`, data);
  },
  addStudent(data) {
    return axios.post(`${process.env.BASE_URL}/student/addStudent`, data);
  },
  updateStudent(data) {
    return axios.put(`${process.env.BASE_URL}/student/updateStudent`, data);
  },
  deleteStudent(data) {
    return axios.delete(`${process.env.BASE_URL}/student/deleteStudent`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/student/exportExcel`, {params: data});
  },
  getStudentFromTypeList(data) {
    return axios.get(`${process.env.BASE_URL}/student/getStudentFromTypeList`, {params: data});
  },
  importData() {
    return axios.post(`${process.env.BASE_URL}/student/importData`, data);
  },
  resetStrudentPassword(data) {
    return axios.post(`${process.env.BASE_URL}/student/resetStrudentPassword`, data);
  },
}

export default student;



// WEBPACK FOOTER //
// ./src/api/student.js